import { GetRaceByIdRequest, GetRaceRequest, RaceSummaryDto } from "@aoe/client";
import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { RaceDetailReponse, RaceListResponse } from "src/app/core/interfaces/RaceResponse.interface";

export const raceActions = createActionGroup({
    source: '[Race]',
    events: {
        'Load race': props<{ payload: GetRaceRequest }>(),
        'Load success': props<RaceListResponse<RaceSummaryDto>>(),
        'Load failed': props<RaceListResponse<RaceSummaryDto>>(),

        'Load race by Id': props<{ payload: GetRaceByIdRequest }>(),
        'Load by Id success': props<RaceDetailReponse>(),
        'Load by Id failed': props<RaceDetailReponse>(),

        'reset selected race': emptyProps()
    }
})